/* Copyright (c) 2020-2021 Nordcloud Oy or its affiliates. All Rights Reserved. */

import * as React from "react";
import styled from "styled-components";

type StyledButtonProps = Pick<Props, "display">;

const StyledButton = styled.button<StyledButtonProps>`
  display: ${({ display }) => display || "block"};
  border: 0;
  outline: none;
  margin: 0;
  padding: 0;
  width: auto;
  overflow: visible;
  background: transparent;
  color: inherit;
  font: inherit;
  line-height: normal;
  appearance: none;

  &::-moz-focus-inner {
    border: 0;
    padding: 0;
  }
`;

type Props = React.ButtonHTMLAttributes<HTMLButtonElement> & {
  display?: string;
  children: React.ReactNode;
};

export function ButtonWrap({ display, children, ...props }: Props) {
  return (
    <StyledButton display={display} {...props}>
      {children}
    </StyledButton>
  );
}
